import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-12 mb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex flex-stack mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "fs-5 fw-boldest mb-0" }, "Làm dự án (nếu có)", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-primary svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Thêm mới", -1)
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "menu-link text-gray-600" }
const _hoisted_10 = { class: "menu-link text-gray-600" }
const _hoisted_11 = { class: "menu-link text-gray-600" }
const _hoisted_12 = { class: "menu-link text-gray-600" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = {
  key: 0,
  class: "fv-row row form-add-record w-100 m-0"
}
const _hoisted_18 = { class: "col-lg-4 col-md-4 col-12 fv-row d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Tên dự án", -1)
const _hoisted_20 = { class: "fv-row" }
const _hoisted_21 = { class: "col-lg-4 col-md-4 col-12 fv-row d-flex flex-column" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label required fw-bold fs-6" }, "Nơi làm", -1)
const _hoisted_23 = { class: "fv-row" }
const _hoisted_24 = { class: "col-lg-4 col-md-4 col-12 fv-row d-flex flex-column" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label fw-bold fs-6" }, "Thời gian", -1)
const _hoisted_26 = { class: "fv-row" }
const _hoisted_27 = { class: "col-12 text-end my-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-warning" }, "Lưu", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (!_ctx.locked)
            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "text-primary cursor-pointer d-flex flex-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr013.svg" })
                ]),
                _hoisted_7
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.tableData.length !=0)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": false,
              classTable: "custom-table-th table-bordered table-hover border border-left-0 border-solid"
            }, {
              "cell-activityName": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(customer.activityName), 1)
              ]),
              "cell-label": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(customer.label), 1)
              ]),
              "cell-studyLocation": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(customer.studyLocation), 1)
              ]),
              "cell-time": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(customer.from) + " - " + _toDisplayString(customer.to), 1)
              ]),
              "cell-actions": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_13, [
                  (!_ctx.locked)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.editRow(customer)),
                        class: "cursor-pointer svg-icon svg-icon-muted svg-icon-2 me-lg-3 me-md-3"
                      }, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                      ], 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  (!_ctx.locked)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.deleteRow(customer)),
                        class: "cursor-pointer svg-icon svg-icon-danger svg-icon-2"
                      }, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                      ], 8, _hoisted_15))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_form, {
        model: _ctx.gapTimeActivities,
        class: "form",
        id: "kt_account_profile_details_project",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        rules: _ctx.validator,
        ref: "submitButton"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.isShowForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_el_form_item, { prop: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            class: "w-100 input-custom",
                            placeholder: "Tên dự án",
                            modelValue: _ctx.gapTimeActivities.label,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gapTimeActivities.label) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_el_form_item, { prop: "activityName" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            class: "w-100 input-custom",
                            placeholder: "Nơi làm",
                            modelValue: _ctx.gapTimeActivities.activityName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gapTimeActivities.activityName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_el_form_item, { prop: "ranktime" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.gapTimeActivities.ranktime,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gapTimeActivities.ranktime) = $event)),
                            placeholder: "Ngày/tháng/năm",
                            format: "DD/MM/YYYY",
                            type: "daterange",
                            class: "w-100"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", {
                      class: "btn btn-secondary me-4",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancle && _ctx.cancle(...args)))
                    }, "Hủy"),
                    _hoisted_28
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}